import * as sessionStorage from '../modules/sessionStorage';
import * as localStorage from '../modules/localStorage';
import { SESSION_STORAGE_KEYS, LOCAL_STORAGE_KEYS } from '../constants';

export const getCurrentCompanyName = (): string => {
    const company = sessionStorage.loadItem && sessionStorage.loadItem(SESSION_STORAGE_KEYS.COMPANY);
    return company?.CompanyName || (localStorage.loadItem && localStorage.loadItem(LOCAL_STORAGE_KEYS.COMPANY_NAME)) || '';
};
